document.addEventListener('DOMContentLoaded', function() {

  /**
   * Handle custom checkbox fields
   */
  function handleCheckboxChange(checkbox) {
    const hiddenInputId = checkbox.dataset.hiddenInputId;
    const hiddenInput = document.getElementById(hiddenInputId);

    if (hiddenInput) {
      hiddenInput.value = checkbox.checked ? 'Yes' : 'No';
    }
  }


  /**
   * Handle custom text fields
   */
  function handleTextInputChange(input) {
    const hiddenInputId = input.dataset.hiddenInputId;
    const hiddenInput = document.getElementById(hiddenInputId);

    if (hiddenInput) {
      hiddenInput.value = input.value;
    }
  }


  /**
   * Get the selected option from either:
   * - a dropdown
   * - a radio/button picker
   */
  function getSelectedOption(input) {

    if (input.tagName === 'SELECT') {
      return input.options[input.selectedIndex];
    }

    if (input.type === 'radio') {
      return input.checked ? input : null;
    }

    return input;
  }


  /**
   * Copy the selected custom option into the existing
   * Shopify line-item property input.
   *
   * Also attach the real Shopify:
   * - variant ID
   * - product ID
   * - SKU
   *
   * These values will be used in the next step when
   * we alter Add to Cart.
   */
  function updateOptionFields(input) {

    const optionName = input.dataset.optionName;
    const blockId = input.dataset.blockId;

    const productFormInput = document.getElementById(
      `product-form-input-${optionName}-${blockId}`
    );

    if (!productFormInput) {
      return;
    }

    const selectedOption = getSelectedOption(input);

    if (!selectedOption) {
      return;
    }

    /*
     * Keep the existing behaviour:
     * Charm 1 = Sun Charm
     * Charm 2 = Heart Charm
     * etc.
     */
    productFormInput.value = selectedOption.value || '';


    /*
     * Add the actual Shopify merchandise information.
     */
    productFormInput.dataset.variantId =
      selectedOption.dataset.variantId || '';

    productFormInput.dataset.productId =
      selectedOption.dataset.productId || '';

    productFormInput.dataset.sku =
      selectedOption.dataset.sku || '';


    /*
     * Also put the same information on the visible picker.
     * This makes it easy for our Add to Cart code to read later.
     */
    input.dataset.selectedVariantId =
      selectedOption.dataset.variantId || '';

    input.dataset.selectedProductId =
      selectedOption.dataset.productId || '';

    input.dataset.selectedSku =
      selectedOption.dataset.sku || '';
  }


  /**
   * Initialise and monitor all custom option pickers
   */
  function handleOptionInputChange(optionInputs) {

    optionInputs.forEach(input => {

      input.addEventListener('change', function() {
        updateOptionFields(this);
      });


      /*
       * Initialise the current selection on page load
       */
      if (
        input.tagName === 'SELECT' ||
        input.checked
      ) {
        updateOptionFields(input);
      }

    });

  }


  /**
   * CUSTOM CHECKBOXES
   */
  const customCheckboxes =
    document.querySelectorAll('.custom-checkbox-input');

  customCheckboxes.forEach(checkbox => {

    checkbox.addEventListener('change', function() {
      handleCheckboxChange(checkbox);
    });

    /*
     * Initialise checkbox value
     */
    handleCheckboxChange(checkbox);

  });


  /**
   * CUSTOM TEXT INPUTS
   */
  const customTextInputs =
    document.querySelectorAll('.custom-text-field');

  customTextInputs.forEach(input => {

    input.addEventListener('input', function() {
      handleTextInputChange(input);
    });

    /*
     * Initialise text value
     */
    handleTextInputChange(input);

  });


  /**
   * CUSTOM OPTION PICKERS
   *
   * Covers both:
   * - dropdowns
   * - radio/button selectors
   */
  const optionInputs = document.querySelectorAll(
    'input[name^="custom_option_"], select[name^="custom_option_"]'
  );

  if (optionInputs.length > 0) {
    handleOptionInputChange(optionInputs);
  }

});